import { SharedComponentsModule } from './../../shared/modules/shared-components.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { HomeComponent } from './home.component';
import { BaseModule } from './../../shared/modules/base/base.module';
import { NgModule } from '@angular/core';
import { HomeRoutingModule } from './home.routing.module';


@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    BaseModule,
    HomeRoutingModule,
    SwiperModule,
    SharedComponentsModule
  ]
})
export class HomeModule { }
